import { useRef } from 'react';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import type { ColumnPickerProps } from '@hotjar/recordings/src/features/RecordingsList';
import { ColumnPicker } from '@hotjar/recordings/src/features/RecordingsList';
import { useCurrentSite } from '@hotjar/site';
import type { ExportFormat } from './types';
import { ExportOptions } from './ExportOptions';

const Container = styled.div`
  box-sizing: border-box;
  display: flex;
`;

const ActionsContainer = styled.div`
  margin-right: ${tokens.spacer.x1};
`;

export type RecordingsListActionsProps = {
  onExportList: (format: ExportFormat) => void;
} & Pick<ColumnPickerProps, 'onColumnsUpdated' | 'listColumns'>;

export const RecordingsListActions = ({
  onExportList,
  onColumnsUpdated,
  listColumns,
}: RecordingsListActionsProps): JSX.Element => {
  // ref needed to force hide when export
  const exportAction = useRef<HTMLSpanElement>(null);

  const { click } = useTrack();
  const { data: currentSite } = useCurrentSite();

  const trackClick = (elementName: string, uiPosition: string) => {
    click(elementName, uiPosition, {
      account_id: currentSite?.account?.id,
      organization_id: currentSite?.organization?.id,
      site_id: currentSite?.id,
    });
  };

  return (
    <Container>
      <ActionsContainer>
        <ColumnPicker
          trackClick={trackClick}
          onColumnsUpdated={onColumnsUpdated}
          listColumns={listColumns}
        />
      </ActionsContainer>

      <ExportOptions
        onExportList={(format: ExportFormat) => {
          onExportList(format);
          exportAction.current?.click();
        }}
      />
    </Container>
  );
};
